/**
 * Insctance of EffectCommand
 * @class EffectCommand
 */
export default class RemoveCommand {
  /**
   * Constructor
   */
  constructor(target, elements) {
    this.label = 'delete'
    this.target = target
    this.elements = elements
  }

  execute() {
    const canvas = this.target.canvas
    this.elements.forEach(element => {
      canvas.remove(element)
    })
    canvas.discardActiveObject()
    canvas.renderAll()
    this.target.emit('removeItem', this.elements)
  }

  undo() {
    const canvas = this.target.canvas
    this.elements.forEach(element => {
      canvas.insertAt(element, element.layer)
    })
  }
}



// WEBPACK FOOTER //
// ./src/model/pixel/command/RemoveCommand.js